module.exports = __webpack_public_path__ + "static/Taneczny weekend zaczarowana kraina_compressed-e86b8d7447af4c7bdd6191f8b30b5627.pdf";